<template>
  <div class="app-container">
    <el-form ref="ruleForm" v-loading="loading" :model="form" label-width="120px">
      <el-form-item label="故事生成方式">
        <el-select v-model="form.type" placeholder="请选择方式">
          <el-option label="问答形式" value="1" />
          <el-option label="条款形式" value="2" />
        </el-select>
        <el-upload
          action="#"
          :auto-upload="false"
          class="left"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :file-list="fileList"
          accept="file"
        >
          <div>
            <el-button size="small" type="primary">
              点击上传(只支持markdown,不支持多选)
            </el-button>
          </div>

        </el-upload>
        <div class="btn">
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </el-form-item>
      <!-- <el-form-item class="width100 center" /> -->
      <el-form-item label="故事" class="width50" required>
        <el-input v-model="form.name" placeholder="请输入故事" />
      </el-form-item>
      <el-form-item label="描述" class="width100" required>
        <el-input v-model="form.desc" placeholder="请输入描述" />
      </el-form-item>
      <el-form-item class="width100 height100" label="内容" required>
        <v-md-preview v-if="fileList.length" v-loading="uploadLoading" :text="form.content" />
        <el-input v-else id="textarea" v-model="form.content" type="textarea" placeholder="请输入内容" />
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import { fileText, saveStory } from '@/api/exercise'
export default {
  data() {
    return {
      form: {
        name: '',
        desc: '',
        content: '',
        type: '2'
      },
      loading: false,
      uploadLoading: false,
      fileList: []
    }
  },
  // updated() {
  //   this.$nextTick(() => {
  //     var textarea = document.getElementById('textarea')
  //     console.log('target', textarea.scrollHeight)
  //     textarea.style.height = textarea.scrollHeight > 80 ? textarea.scrollHeight + 'px' : '80px'
  //   })
  // },
  methods: {
    onSubmit() {
      if (!this.form.name) {
        this.$message({
          message: `请填写故事名称`,
          type: 'error',
          duration: 2 * 1000
        })
      } else if (!this.form.desc) {
        this.$message({
          message: `请填写故事描述`,
          type: 'error',
          duration: 2 * 1000
        })
      } else if (!this.form.content) {
        this.$message({
          message: `请填写故事内容`,
          type: 'error',
          duration: 2 * 1000
        })
      } else {
        this.loading = true
        const params = {
          name: this.form.name,
          description: this.form.desc,
          article: this.form.content,
          type: this.form.type
        }
        saveStory(params).then(() => {
          this.$message({
            message: `保存成功`,
            type: 'success',
            duration: 2 * 1000
          })
          this.$router.push({ name: 'storyList' })
        }).finally(() => {
          this.loading = false
        })
      }
    },

    // resetForm(formName) {
    //   this.$confirm('此操作将重置整个表单, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     console.log(2222, this)
    //     this.$refs[formName].resetFields()
    //   })
    // },
    // 删除文件
    handleRemove() {
      this.fileList = []
      this.form.content = ''
      // var textarea = document.getElementById('textarea')
      // textarea.style.height = '80px'
    },
    handleChange(file, fileList) {
      this.uploadLoading = true
      this.fileList = [file]
      fileList = this.fileList
      console.log(8888, file)
      const formData = new FormData()
      formData.append('file', file.raw)
      fileText(formData).then(res => {
        console.log(121212, res)
        this.form.content = res.data
      }).catch(() => {
        this.fileList = []
        fileList = this.fileList
      }).finally(() => {
        this.uploadLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-form{
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .el-form-item__content{
    display: flex;
    height: 100%;
    .vuepress-markdown-body:not(.custom){
      padding: 0;
    }
  }
  .el-textarea__inner{
    resize: none;
    height: 100%;
  }
  .el-upload{
    margin-right: 20px;
  }
  .el-select{
    flex-shrink: 0;
  }
}
.btn{
  text-align: end;
  position: absolute;
  right: 0;
}
.v-md-editor-preview{
  overflow: auto;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  padding: 10px 20px;
  width: 100%;
}
.left{
  text-align: left;
  margin-left: 20px;
  display: flex;
}
.center{
  text-align: center;
}
.width30{
  width: 30%;
}
.width50{
  width: 50%;
}
.height100{
  margin-bottom: 0;
  flex:1;
  overflow: hidden;
}
</style>

